import { Modal, Form, Row, Col, Button } from "react-bootstrap";

const ExperienceModal = ({
  show,
  onHide,
  expForm,
  setExpForm,
  onSave,
  expModalIndex,
}) => {
  const handleChange = (field, value) => {
    setExpForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    await onSave(); // actual save from ProfilePage
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {expModalIndex !== null ? "Edit Experience" : "Add Experience"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="required-hint">
          * Required fields are marked with an asterisk
        </p>

        <Form>
          <Form.Group className="mb-3">
            <Form.Label>
              Organization Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={expForm.companyName}
              onChange={(e) => handleChange("companyName", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Position <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={expForm.jobTitle}
              onChange={(e) => handleChange("jobTitle", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Industry</Form.Label>
            <Form.Control
              type="text"
              value={expForm.industry}
              onChange={(e) => handleChange("industry", e.target.value)}
            />
          </Form.Group>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Start Date *</Form.Label>
                <Form.Control
                  type="date"
                  value={expForm.startDate}
                  onChange={(e) => handleChange("startDate", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  disabled={expForm.current}
                  value={expForm.endDate}
                  onChange={(e) => handleChange("endDate", e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Check
            className="mb-3"
            type="checkbox"
            checked={expForm.current}
            label="I currently work here"
            onChange={(e) => handleChange("current", e.target.checked)}
          />

          <Form.Group className="mb-3">
            <Form.Label>Years of Experience (Tech)</Form.Label>
            <Form.Control
              type="number"
              value={expForm.yearsInTech}
              onChange={(e) => handleChange("yearsInTech", e.target.value)}
            />
          </Form.Group>

          <Form.Check
            className="mt-3"
            type="checkbox"
            checked={expForm.canGiveReferral ?? true}
            label="I can give referrals"
            onChange={(e) => handleChange("canGiveReferral", e.target.checked)}
          />
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExperienceModal;
